export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["计算费用"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退还"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["地址"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["费用"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最终金额"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果您接受更新的条件，请批准入账"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果不接受，您可以将资金退还给发送方（将收取退还费用）。"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["有AML风险"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["因此重新计算了手续费"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["因此入账金额为"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有检测到新收入"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日期"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退还"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已完成"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待处理"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已取消"])}
}